export const formatSamplingEventCode = (samplingEventCode: string): string => {
    return samplingEventCode.slice(0, 3) + '-' + samplingEventCode.slice(3);
};

// Batch number is eventId + B + number
export const getBatchNumberFromBatchId = (batchId: string, eventId: string): number => {
    return Number(batchId.replace(eventId + 'B', ''));
};
